import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, type Auth } from "firebase/auth";

// Reads Firebase config from Vite env vars (same var names as web/admin so the
// deployment pipeline supplies them once). Lazily initialized so a missing
// config surfaces as a clear error rather than a blank page.
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string,
  appId: import.meta.env.VITE_FIREBASE_APP_ID as string,
};

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

// Always the real Firebase project, including on localhost — see
// deploy/local/README.md. Local dev deliberately does NOT use the Auth
// emulator: sign-in should exercise the same tokens, claims and JWKS
// verification the deployed console does, and the server has no code path that
// accepts anything weaker.
export function firebaseAuth(): Auth {
  if (!auth) {
    if (!firebaseConfig.apiKey) {
      throw new Error(
        "Firebase not configured. Set VITE_FIREBASE_* in dashboard/.env.local",
      );
    }
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
  }
  return auth;
}
